"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseExistsResponse = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ViewCaseDataSerializer_1 = require("./ViewCaseDataSerializer");
const EmobilityCaseAction_1 = require("./EmobilityCaseAction");
const CaseActionType_1 = require("./enums/CaseActionType");
class CaseExistsResponse extends base_models_1.Serializable {
}
exports.CaseExistsResponse = CaseExistsResponse;
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: true,
        description: 'true when BPM Case with the given id exists, allowing customer to upload images for the enrichment form',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    tslib_1.__metadata("design:type", Boolean)
], CaseExistsResponse.prototype, "exists", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '12345',
        description: 'BPM id of the case',
    }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], CaseExistsResponse.prototype, "caseId", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: [
            {
                action: CaseActionType_1.CaseActionType.CallbackCustomer,
                actionDate: new Date('2023-05-25').toISOString(),
                operator: 'Gerard Eit',
            },
        ],
        description: 'The open actions that has to be taken',
    }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => EmobilityCaseAction_1.EmobilityCaseAction),
    tslib_1.__metadata("design:type", Array)
], CaseExistsResponse.prototype, "actions", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: {
            emobilityId: '12345',
            accountId: '0123456789',
            state: 'WAITFORDATACOLLECTION',
        },
        description: 'case data in BPM',
    }),
    (0, class_transformer_1.Type)(() => ViewCaseDataSerializer_1.ViewCaseDataSerializer),
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", ViewCaseDataSerializer_1.ViewCaseDataSerializer)
], CaseExistsResponse.prototype, "caseData", void 0);
